import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
// import "../styles/logout.css"; // Optional for styles

const Logout = () => {
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const performLogout = async () => {
      try {
        // Sign out from Firebase
        await signOut(auth);

        // Clear session cookies
        document.cookie =
          "__session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

        alert("You have been logged out.");
        navigate("/login"); // Redirect to login page
      } catch (error) {
        console.error("Error during logout:", error);
        alert("Failed to log out. Redirecting to the main page...");
        navigate("/"); // Redirect to the main page if logout fails
      }
    };

    performLogout();
  }, [auth, navigate]);

  return (
    <div className="logout-container">
      <div className="mdl-card mdl-shadow--2dp logout-card">
        <h4 className="mdl-card__title">Logging you out...</h4>
      </div>
    </div>
  );
};

export default Logout;
